import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Create_Admin = (user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newRealEstateManager`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_ADMIN,
        payload: res.data.data,
      });
      // swal({
      //   title: "Good job!",
      //   text: "Create  Admin  Successfuly !",
      //   icon: "success",
      //   timer: 1000,
      // });
    } catch (error) {
      toast.error("Admin Created Error");
    }
  };
};
export const Get_List_Admin = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/listOfManagers`, config);
      dispatch({
        type: actions.GET_LIST_ADMINS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Get_List_Branches = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getBranchs`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_LIST_Branches,
          payload: res.data.data,
          branch_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Get_List_Active_Branches = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getActiveBranchStatus`, config);
      dispatch({
        type: actions.GET_LIST_ACTIVE_BRANCHES,
        payload: res.data.data,
        branch_obj_salary: res.data.data[0].branchId,
      });
    } catch (error) {}
  };
};

export const Create_Branch = (user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(`/api/v1/newBranch`, { ...user }, config);
      dispatch({
        type: actions.CREATE_Branch,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Profile_Branch = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getBranch/${id}`, config);
      dispatch({
        type: actions.VIEW_PROFILE_Branch,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Branch_Status = (id, status) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.put(
        `/api/v1/updateBranchStatus/${id}?status=${status}`,
        config
      );
      dispatch({ type: actions.UPDATEING_STATUS });
      // swal({
      //   title: "Good job!",
      //   text: "Update  Status  Successfuly !",
      //   icon: "success",
      //   timer: 1000,
      // });
    } catch (error) {}
  };
};

export const Change_Agent_Password = (id, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/updateAgentPassword/${id}`,
        { ...user },
        config
      );
      dispatch({
        type: actions.UPDATEING_Agent_PASSWORD_BY_ADMIN,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_Agents_By_Each_Branch = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getAgentByBranch/${id}`, config);
      dispatch({
        type: actions.VIEW_DETAIL_OF_AGGENT_BRANCH,
        payload: res.data.data,
        branch_obj_salary:
          res.data.data.length === 0 ? [] : res.data.data[0].branchId,
      });
    } catch (error) {}
  };
};

export const Get_Agents_By_Each_Branch_Name = (branchid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getAgentByBranchName/${branchid}`,
        config
      );
      dispatch({
        type: actions.GET_AGENT_BY_NAME,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Create_ToDo_Branch_To_Agent = (agentid, user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/AddAgentTodoRE/${agentid}`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_BRANCH_TODO_AGENT,
        payload: res.data.data,
      });
    } catch (error) {
      toast.error("Create_ToDo_Branch_To_Agent Error");
    }
  };
};
export const Get_ToDo_Branch_To_Agent = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getREAgentsTodos`, config);
      if (res.data.status === true) {
        dispatch({
          type: actions.GET_REALESTATE_ADDTODO_TOAGENT,
          payload: res.data.data,
          todo_status: true,
        });
      }
    } catch (error) {}
  };
};

export const Create_HR = (user) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/newRealEstateManager?role=hr`,
        { ...user },
        config
      );
      dispatch({
        type: actions.CREATE_HRS,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
